export default __webpack_public_path__ + "static/media/editeurs-01.a7dbf5fc.webp";